import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";

const LoaderWithDelay = ({ delay = 500, ...rest }) => {
  const [disable, setDisable] = useState(true);
  useEffect(
    () => {
      const timer = setTimeout(() => setDisable(false), delay);
      return () => clearTimeout(timer);
    },
    // eslint-disable-next-line
    []
  );
  return <Loader disabled={disable} {...rest} />;
};

export default LoaderWithDelay;
